import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';

import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import Props from '@/components/app/product/components/release-details/expanded-rate/type';

import localization from '@/constant/localization';

export default function ExpandedRate({
  value,
  textClassName,
  showOutOf5 = false,
  size = 17,
  starClassName,
  wrapperClassName,
}: Props) {
  return (
    <Container center className={cn(wrapperClassName, 'gap-2')}>
      <Container className='ml-1.5' center>
        <Text className={cn(textClassName, 'text-[15px] text-[#76767C]')}>
          {value === 5 ? value : value.toFixed(1)}
        </Text>
        {showOutOf5 && (
          <Text className={cn(textClassName, 'pr-[1px] text-[15px] text-[#76767C]')}>
            {localization.outOf5}
          </Text>
        )}
      </Container>
      <Container center className={cn(starClassName, 'flex-row-reverse')}>
        {value >= 1 ? (
          <FaStar size={size} fill='#FEA000' />
        ) : value >= 0.5 ? (
          <FaStarHalfAlt size={size} fill='#FEA000' />
        ) : (
          <FaRegStar size={size} fill='#FEA000' />
        )}
        {value >= 2 ? (
          <FaStar size={size} fill='#FEA000' />
        ) : value >= 1.5 ? (
          <FaStarHalfAlt size={size} fill='#FEA000' />
        ) : (
          <FaRegStar size={size} fill='#FEA000' />
        )}
        {value >= 3 ? (
          <FaStar size={size} fill='#FEA000' />
        ) : value >= 2.5 ? (
          <FaStarHalfAlt size={size} fill='#FEA000' />
        ) : (
          <FaRegStar size={size} fill='#FEA000' />
        )}
        {value >= 4 ? (
          <FaStar size={size} fill='#FEA000' />
        ) : value >= 3.5 ? (
          <FaStarHalfAlt size={size} fill='#FEA000' />
        ) : (
          <FaRegStar size={size} fill='#FEA000' />
        )}
        {value >= 5 ? (
          <FaStar size={size} fill='#FEA000' />
        ) : value >= 4.5 ? (
          <FaStarHalfAlt size={size} fill='#FEA000' />
        ) : (
          <FaRegStar size={size} fill='#FEA000' />
        )}
      </Container>
    </Container>
  );
}
